export default function () {
  return [
    {
      type: 'Input',
      title: '所属CCO组织',
      readOnly: true,
      [$field]: 'orgName',
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '加入时间',
      [$field]: 'joinPartyDate',
      rules: ['']
    }
  ]
}